
const environments = {
  development: {
    baseURL: "https://testing.unzippd.co.uk",
    env: "development",
  },
  testing: {
    baseURL: "https://testing.unzippd.co.uk",
    env: "testing",
  },
  staging: {
    baseURL: "https://staging.unzippd.co.uk",
    env: "staging",
  },
  production: {
    baseURL: "https://backend.unzippd.co.uk",
    env: "production",
  },
};

export const ENVIRONMENT_TARGETS = {
  staging: {
    key: "staging",
    label: "Staging",
    baseURL: environments.staging.baseURL,
  },
  production: {
    key: "production",
    label: "Production",
    baseURL: environments.production.baseURL,
  },
};

export const getEnvironmentConfig = () => {
  const env = import.meta.env.VITE_ENV || process.env.VITE_ENV || "production";
  const fallbackConfig = environments[env] || environments.production;
  const baseURL =
    import.meta.env.VITE_API_URL ||
    process.env.VITE_API_URL ||
    fallbackConfig.baseURL;

  return {
    baseURL,
    env,
    isProduction: env === "production",
    isTestingEnv: env === "testing",
    isStagingEnv: env === "staging",
    isDevelopment: env === "development",
  };
};

export const getTargetEnvironmentBaseUrl = (environmentKey) => {
  const target = ENVIRONMENT_TARGETS[environmentKey];
  return target?.baseURL || environments.production.baseURL;
};
